module.exports = __webpack_public_path__ + "img/finish-alt.9eaa0639.svg";